export const weekHeaderMinHeight = 64
export const largeViewWeekHeaderMinHeight = 83
export const headerMinHeight = 83
export const titleDescMinHeight = 141
export const dayViewMinHeight = 600
export const SEL_DAY_PERC_WIDTH = 0.22
